// extracted by mini-css-extract-plugin
export default {"content":"ContactInfo_content__ALDR1","button":"ContactInfo_button__c3o71","actions":"ContactInfo_actions__dDHV1","small":"ContactInfo_small__ZfuKz"};